<template>
  <v-breadcrumbs :items="items" class="px-0 py-1 d-none d-sm-inline-block breads">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :to="item.to"
          exact
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
  export default {
    name: 'BreadCrumbs',
    props: ['items']
  }
</script>